<template>
  <div class="NewsDetails">
    <div class="NewsDetails-message" :style="{ height: screenheight }">
      <div
        class="wow animate__zoomIn"
        data-wow-duration="1s"
        data-wow-delay="0.5s"
      >
        <h3>企业资讯 实时共享</h3>
        <p>Fast, efficient, safe and auspicious logistics</p>
      </div>
    </div>
    <div class="NewsDetails-product wow animate__zoomIn">
      <div class="NewsDetails-product-content">
        <p class="product-title">{{ newsInfo.newsTitle }}</p>
        <p class="product-time">时间：{{ dataInfo(newsInfo.updateTime) }}</p>
        <p v-html="newsInfo.newsContent"></p>
        <!-- <div v-html="newsInfo.newsPicture"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  name: "NewsDetails",
  components: {},
  data() {
    return {
      pid: 0,
      newsInfo: {},
      screenheight: document.documentElement.clientHeight + "px",
      rawHtml: '<span style="color: red">这是红色的文本</span>',
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.addEventListener("resize", () => {
      this.screenheight =
        Math.round((document.documentElement.clientWidth * 401) / 1440) + "px";
    });
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true, // 在移动设备上触发动画（默认为true）
      live: true, // 对异步加载的内容进行操作（默认值为true）
      callback: function(box) {
        // 每次启动动画时都会触发回调,传入的参数是正在设置动画的DOM节点
      },
      scrollContainer: null, // 可选滚动容器选择器，否则使用window，
      resetAnimation: true, // 结束时重置动画（默认为true）
    });
    wow.init();

    window.scrollTo(0, 0);
    this.screenheight =
      Math.round((document.documentElement.clientWidth * 401) / 1440) + "px";
    this.loadData();
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        if (val.hash) {
          this.$router.push("/" + val.hash);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    loadData() {
      this.$api
        .newsInfo(this.pid)
        .then((res) => {
          if (res.status == 200) {
            this.newsInfo = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.newsInfo = {};
        })
        .finally(() => {});
    },
    dataInfo(val) {
      const date = new Date(val);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份是从 0 开始计数的，所以需要加 1
      const day = date.getDate();

      const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      }`;
      return formattedDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  min-width: 1000px;
  &-message {
    width: 100%;
    height: 100%; /* 如果高度未知或想要根据内容调整 */
    background: url(../assets/img/parcel/parcelBanner.png) no-repeat center;
    background-size: cover;
    background-position: center;
    color: #fff;
    box-sizing: border-box;
    position: relative;
    div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); /* 使用transform来居中元素 */
      transition: transform 0.5s ease;
      text-align: center;
      overflow: hidden;
      h3 {
        font-size: 48px;
        font-weight: 600;
        color: #fff;
        margin: 0;
      }
      p {
        font-size: 20px;
        font-weight: 400;
        color: #fff;
      }
    }
  }
  &-product {
    margin: 0 12%;
    box-sizing: border-box;
    background-color: #fff;
    &-content {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      text-align: center;
      padding: 48px 0;
      img {
        width: 80%;
        margin: 20px auto;
      }
      .product-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #1d2129;
        font-style: normal;
        margin: 0;
      }
      .product-time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #86909c;
        text-align: right;
        font-style: normal;
      }
      .product-content {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #4e5969;
        font-style: normal;
        text-align: left;
      }
    }
  }
}
</style>
